var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenulineg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 27.5H6.576V21.816C6.576 20.934 6.478 19.688 6.422 18.792H6.478L7.29 21.13L9.236 26.464H10.104L12.05 21.13L12.862 18.792H12.918C12.848 19.688 12.75 20.934 12.75 21.816V27.5H13.968V17.238H12.4L10.44 22.726C10.202 23.44 9.978 24.154 9.74 24.868H9.67C9.418 24.154 9.18 23.44 8.942 22.726L6.968 17.238H5.4V27.5ZM17.1813 27.5H23.2573V26.394H18.4833V22.656H22.3753V21.55H18.4833V18.33H23.1033V17.238H17.1813V27.5ZM25.8318 27.5H27.0638V22.11C27.0638 21.032 26.9658 19.94 26.9098 18.904H26.9658L28.0718 21.018L31.8098 27.5H33.1398V17.238H31.9078V22.572C31.9078 23.636 32.0058 24.784 32.0758 25.82H32.0058L30.9138 23.706L27.1758 17.238H25.8318V27.5ZM39.9953 27.682C42.0953 27.682 43.6913 26.562 43.6913 23.258V17.238H42.4453V23.3C42.4453 25.778 41.3673 26.548 39.9953 26.548C38.6653 26.548 37.6153 25.778 37.6153 23.3V17.238H36.3133V23.258C36.3133 26.562 37.9093 27.682 39.9953 27.682Z",
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 31.5,
    width: 43,
    height: 2,
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenulineg);
export default __webpack_public_path__ + "static/media/menulineg.2e716fc3f280f7d72f1e69f94d5a072a.svg";
export { ForwardRef as ReactComponent };